/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import React from 'react';
import PropTypes from 'prop-types';

import history from '../common/history';
import ErrorDisplay from '../common/components/ErrorDisplay';
import OzErrorCard from '../common/components/OzErrorCard';
import * as constants from '../common/constants';

/**
 * A Container that handles error pages.
 *
 * @author Hari Gangadharan
 */
const ErrorContainer = ({ errorCode, isOzProduct, isMentor }) => {
  const urlParams = new URLSearchParams(history.location.search);
  return (
    isOzProduct && (errorCode === constants.HTTP_500 || errorCode === constants.HTTP_502 || errorCode === constants.HTTP_503 || errorCode === constants.BETA_EXPIRED) ? (
      <OzErrorCard
        isMentor={isMentor}
        langKeyPrefix="errors"
        textKey={urlParams.get('textKey')}
        errorCode={errorCode}
      />
    ) : (
      <ErrorDisplay
        errorCode={errorCode}
        langKeyPrefix="errors"
        textKey={urlParams.get('textKey')}
        url={urlParams.get('url')}
      />
    ));
};

ErrorContainer.propTypes = {
  errorCode: PropTypes.string.isRequired,
  isOzProduct: PropTypes.bool,
  isMentor: PropTypes.bool
};

ErrorContainer.defaultProps = {
  isOzProduct: false,
  isMentor: false
};

export default ErrorContainer;
